import type { Box, FullCardInfo } from '@lub0v/santa-utils';

export function cardIsFilled(card: FullCardInfo | null, box: Box): boolean {
  if (!card?.username?.trim()) {
    return false;
  }
  if (box.useWish && !card.wish?.trim()) {
    return false;
  }
  // Completion is a reminder, not a requirement for saving the card.
  if (box.usePost && !card.postalAddress?.trim()) {
    return false;
  }
  if (box.isPhoneRequired && !card.phone?.trim()) {
    return false;
  }
  return true;
}
